import {
  Content,
  ContentHeader,
  Header,
  Page,
  SupportButton,
} from '@backstage/core-components';
import React, { useEffect } from 'react';
import { DatabricksProvider } from './databricks-provider';

const ChatbotPage = () => {
  return (
    <Page themeId="tool">
      <Header title="Chatbot" />
      <Content>
        <ContentHeader title="">
          <SupportButton>This is the chatbot page</SupportButton>
        </ContentHeader>
        {/* <ChatBox service={new DatabricksProvider()} /> */}
      </Content>
    </Page>
  );
};

export default ChatbotPage;
